import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    FormControl,
    TextField,
    Autocomplete,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
  } from "@mui/material";
  import ButtonComponent from "./ButtonComponent";
import { COLORS } from "../config/theme";
import { updateExpediente }   from "../services/expediente.service";

export default function MoverDeOficina({
    setIsVisibleModal,
    oficinasList,
    id_expediente,
    setReload,
    reload,
  }) {
    const [selectedOficina, setSelectedOficina] = useState(null);

    const onClose = () => {
        setIsVisibleModal(false);
        setSelectedOficina(null);
        setReload(!reload);
    };

    const onMove = () => {
        updateExpediente(id_expediente, {id_oficina_actual: selectedOficina.id})
        .then(() => onClose());
    }


    return (
    <>
        <Box p={2}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <FormControl fullWidth>
                <Autocomplete
                size="small"
                options={oficinasList}
                getOptionLabel={(option) => option.nombre}
                value={selectedOficina}
                onChange={(e, value) => setSelectedOficina(value)}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    label="Selecciona una oficina de destino"
                    variant="outlined"
                    />
                )}
                />
            </FormControl>
            </Grid>

            <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
                <ButtonComponent
                name="Mover expediente"
                toAction={() => onMove()}
                />
                <div style={{ width: "5px" }}></div>
                <ButtonComponent
                name="Cancelar"
                toAction={onClose}
                color={COLORS.DANGER}
                />
            </Box>
            </Grid>
        </Grid>
        </Box>
    </>
    );

}